import React, { useEffect, useState } from "react";
import "../Zone/Zone.css";
import "../Overview/Overview.css";
import { fetchEmployeeCaptures } from "../../Services/locationEntries";

function fmtDate(ts) {
  if (!ts) return "—";
  // captures.createdAt is a plain ms number; captureStatus timestamps may be Firestore Timestamps
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return (
    d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" }) +
    ", " +
    d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false })
  );
}

const APPROVAL_VARIANT = { APPROVED: "ok", PENDING: "warn", REJECTED: "bad" };

function EmployeeDetail({ className, employee, onBack }) {
  const [captures, setCaptures] = useState(null);

  useEffect(() => {
    if (!employee?.documentId) return;
    setCaptures(null);
    fetchEmployeeCaptures(employee.documentId)
      .then(setCaptures)
      .catch(() => setCaptures([]));
  }, [employee?.documentId]);

  if (!employee) return null;

  const contact = employee.phoneNumber || employee.email || "—";
  const typeVariant = employee.type === "admin" ? "info" : "ok";
  const lastAt = employee.captureStatus?.lastCapturedAt;
  const lastIn = employee.captureStatus?.location
    ? `PCT-${employee.captureStatus.location.PCTNo || ""} · ${employee.captureStatus.location.address || ""}`
    : "—";

  return (
    <div className={className} data-cy="employee-detail-screen">
      <div className="subhdr">
        <div className="back" onClick={onBack}>
          <svg viewBox="0 0 24 24">
            <polyline points="15,18 9,12 15,6" />
          </svg>
        </div>
        <div className="subhdr-info">
          <div className="subhdr-crumb">Employee</div>
          <div className="subhdr-title">{employee.name || "—"}</div>
        </div>
        <span className={`pill ${typeVariant}`}>
          <span className="dot" />
          {employee.type || "employee"}
        </span>
      </div>
      <div className="divider" />
      <div className="scroll">

        {/* Contact */}
        <div style={{ padding: "8px 20px 0", fontSize: "var(--text-sm)", color: "var(--t3)", fontFamily: "var(--font-mono)", letterSpacing: ".03em" }}>
          {contact}
        </div>

        {/* Last capture info grid */}
        <div className="stats" style={{ gridTemplateColumns: "1fr 1fr", marginTop: "12px", marginBottom: "0" }}>
          <div className="stat" style={{ textAlign: "left", padding: "12px 14px" }}>
            <div className="stat-l">Last Captured At</div>
            <div style={{ fontSize: "var(--text-sm)", fontWeight: 500, color: "var(--t2)", marginTop: "6px", lineHeight: 1.3 }}>
              {fmtDate(lastAt)}
            </div>
          </div>
          <div className="stat" style={{ textAlign: "left", padding: "12px 14px" }}>
            <div className="stat-l">Last Captured In</div>
            <div style={{ fontSize: "var(--text-sm)", fontWeight: 500, color: "var(--t2)", marginTop: "6px", lineHeight: 1.3 }}>
              {lastIn}
            </div>
          </div>
        </div>

        {/* Captures list */}
        <div className="sec-hdr" style={{ marginTop: "16px" }}>
          <div className="t-section">Captures</div>
          {captures && <div className="t-label">{captures.length}</div>}
        </div>

        {captures === null && (
          <div style={{ padding: "12px 20px", fontSize: "var(--text-base)", color: "var(--t3)" }}>Loading…</div>
        )}
        {captures?.length === 0 && (
          <div style={{ padding: "12px 20px", fontSize: "var(--text-base)", color: "var(--t3)" }}>No captures found.</div>
        )}
        {captures?.length > 0 && (
          <div className="lrows">
            {captures.map((c) => {
              const pct = c.location?.PCTNo ? `PCT-${c.location.PCTNo}` : "";
              const addr = c.location?.address || "";
              const approvalStatus = c.approval?.status;
              return (
                <div key={c.documentId} className="lrow" style={{ cursor: "default" }}>
                  <div className="li">
                    <div className="ln">{[pct, addr].filter(Boolean).join(" · ") || "—"}</div>
                    <div className="ls">{fmtDate(c.createdAt)}</div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px", flexShrink: 0 }}>
                    {approvalStatus && (
                      <span className={`snap-pill ${APPROVAL_VARIANT[approvalStatus] || "neutral"}`}>
                        {approvalStatus}
                      </span>
                    )}
                    <span className={`snap-pill ${c.success ? "ok" : "bad"}`}>
                      {c.success ? "Success" : "Failed"}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div style={{ height: "20px" }} />
      </div>
    </div>
  );
}

export default EmployeeDetail;
